import { ImageLegendVariant } from '../image-legend';

interface LegendLabels {
  leftLabel?: string;
  rightLabel?: string;
}

/**
 * Returns appropriate legend labels based on the selected analysis type
 *
 * @param variant - The variant of the image legend
 * @returns The legend labels
 */
function getLegendLabels(variant: ImageLegendVariant): LegendLabels {
  switch (variant) {
    case ImageLegendVariant.AttentionMap:
      return { leftLabel: 'Less attention', rightLabel: 'More attention' };
    case ImageLegendVariant.GazeSequence:
      return { leftLabel: 'Gaze Sequence points' };
    case ImageLegendVariant.FocalPoints:
      return { leftLabel: 'Focal Points' };
    case ImageLegendVariant.AttentionDrivers:
      return { leftLabel: 'Low driver', rightLabel: 'High driver' };
    case ImageLegendVariant.AttentionDetractors:
      return { leftLabel: 'Low detractor', rightLabel: 'High detractor' };
    default:
      return {
        leftLabel: 'Original image',
      };
  }
}

export { getLegendLabels };
export type { LegendLabels };
